import { gql } from '@apollo/client';
import { queryClientSideGraphQL } from '../../../integration/graphql.client';

const QUERIES = {
  GET_ACCOUNT_OTC: gql`
    query accountOtc(
      $accountId: String!
      $systemId: String!
      $telNo: String!
      $recaptcha: String!
      $recaptchaVersion: String!
    ) {
      accountOtc(
        accountId: $accountId
        systemId: $systemId
        telNo: $telNo
        recaptcha: $recaptcha
        recaptchaVersion: $recaptchaVersion
      ) {
        accountnumber
        onetimecode
        isR6
        isION
        ionServices
      }
    }
  `,
};

/**
 * @name getAccountOtc
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to the accountOtc
 */
export const getAccountOtc = async (graphql, variables) => {
  try {
    const data = await queryClientSideGraphQL(graphql, {
      query: QUERIES.GET_ACCOUNT_OTC,
      variables,
    });
    return data;
  } catch (error) {
    throw new Error(error);
  }
};
